import { ReactNode, createContext, useMemo } from 'react';
import * as ResendReceiptDialog from 'assets/js/pages/transactions/ResendReceiptDialog';
import * as Form from 'components/form';
import * as ResendItemDialog from 'components/resend-item-dialog';
import { useCurrentTransactionOrById } from 'customHooks/useCurrentTransactionOrById';
import { Transaction } from 'types/domain';

interface ITransactionActionsContext {
    transaction: Transaction;
}

const TransactionActionsContext = createContext<ITransactionActionsContext>({
    transaction: {} as Transaction,
});

interface TransactionActionsProviderProps extends ITransactionActionsContext {
    children: ReactNode;
}
const TransactionActionsProvider = (props: TransactionActionsProviderProps) => {
    const { transaction, children } = props;
    const transactionMemo = useMemo(() => ({ transaction }), [transaction]);

    return (
        <TransactionActionsContext.Provider value={transactionMemo}>
            {children}
        </TransactionActionsContext.Provider>
    );
};

interface ResendFormValues {
    email: string;
}

const TransactionActionsResend = () => {
    const { data: transaction } = useCurrentTransactionOrById();
    const transactionEmail = transaction?.email ?? '';
    const methods = Form.useGivebutterForm<ResendFormValues>({
        defaultValues: {
            email: transactionEmail,
        },
    });

    return (
        <Form.Provider {...methods}>
            <ResendReceiptDialog.Root>
                <ResendItemDialog.DropdownItem />
                <ResendItemDialog.Portal>
                    <ResendItemDialog.Overlay />
                    <ResendItemDialog.Content>
                        <ResendItemDialog.Icon />
                        <ResendItemDialog.Header />
                        <ResendItemDialog.FormBody />
                    </ResendItemDialog.Content>
                </ResendItemDialog.Portal>
            </ResendReceiptDialog.Root>
        </Form.Provider>
    );
};

const Root = TransactionActionsProvider;
const Resend = TransactionActionsResend;

export {
    TransactionActionsContext,
    //
    TransactionActionsProvider,
    TransactionActionsResend,
    //
    Root,
    Resend,
};
